const ODO_DIGITS = [0, 1, 2, 3, 4, 5];

const Odometer = ({ digits }) => (
  <span>
    {digits.map((d, i) => (
      <span key={i} className="rl-odo">
        <span className="rl-reel" style={{ "--d": d }}>
          {ODO_DIGITS.map((n) => (
            <span key={n}>
              {n}
              <br />
            </span>
          ))}
        </span>
      </span>
    ))}
    <span>ms</span>
  </span>
);

export const InfraBand = () => {
  return (
    <section
      data-testid="infra-band-section"
      className="relative overflow-hidden border-b border-[#1e293b]/60 py-20"
    >
      <img
        src="https://images.unsplash.com/photo-1584931423298-c576fda54bd2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHwxfHxnbG9iYWwlMjBkaXN0cmlidXRlZCUyMGNsb3VkJTIwY2x1c3RlciUyMG1hcHxlbnwwfHx8fDE3OTI0MTgwNTd8MA&ixlib=rb-4.1.0&q=85"
        alt="Global distributed cloud cluster map with active edge computing routes"
        loading="lazy"
        className="absolute inset-0 h-full w-full object-cover opacity-25"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-[#070b10] via-[#0f172a]/85 to-[#070b10]"></div>

      <div className="relative z-10 mx-auto flex max-w-6xl flex-col items-start justify-between gap-8 px-6 md:flex-row md:items-center">
        <div className="rl-reveal">
          <span className="font-mono text-xs uppercase tracking-wider text-[#22d3ee]">
            Sub-second warm boots
          </span>
          <h2 className="mt-1 text-2xl font-bold text-white md:text-3xl">
            Global edge clusters with persisted disk snapshots
          </h2>
        </div>
        <div className="rl-reveal flex items-center gap-8 font-mono">
          <div className="text-center" data-testid="infra-boot-latency">
            <div className="text-3xl font-bold text-white">
              <Odometer digits={[2, 4, 0]} />
            </div>
            <div className="mt-1 text-xs text-[#64748b]">Boot Latency</div>
          </div>
          <div className="text-center" data-testid="infra-isolation">
            <div className="text-3xl font-bold text-[#22d3ee]">100%</div>
            <div className="mt-1 text-xs text-[#64748b]">Isolated Sandboxes</div>
          </div>
        </div>
      </div>
    </section>
  );
};
